import {SOPostProcessRole} from '../../core/process-role/so-post-process-role';
import {ProcessRoleCore} from './process-role.core';
import {SOGetProcessRole} from '../../core/process-role/so-get-process-role';
import {FormField, SelectionOption} from 'lionheartland';
import {postProcessRoleFormFieldOptions} from './post-process-role-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ProcessCore} from '../process/process.core';
import {SOGetProcess} from '../../core/process/so-get-process';
import {RoleCore} from '../role/role.core';
import {SOGetRole} from '../../core/role/so-get-role';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostProcessRole extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postProcessRoleFormFieldOptions);

  RequestClass = SOPostProcessRole

  constructor(
    public entityCore: ProcessRoleCore
  ) {
    super();
    if (postProcessRoleFormFieldOptions.process) {
      postProcessRoleFormFieldOptions.process.makeCore = true;
    }
    if (postProcessRoleFormFieldOptions.role) {
      postProcessRoleFormFieldOptions.role.makeCore = true;
    }
    if (postProcessRoleFormFieldOptions.project) {
      postProcessRoleFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'process',
        SOGetProcess,
      ),
      this.getFormValueFromIdentifier(
        'role',
        SOGetRole,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}